// extracted by mini-css-extract-plugin
module.exports = {"interesting":"Interesting_interesting__28Q-i","interestingText":"Interesting_interestingText__LIja9"};